__turbopack_context__.v({
  "divider": "WhyItMatters-module__5ozi9G__divider",
  "eyebrow": "WhyItMatters-module__5ozi9G__eyebrow",
  "grid": "WhyItMatters-module__5ozi9G__grid",
  "headingWrap": "WhyItMatters-module__5ozi9G__headingWrap",
  "icon": "WhyItMatters-module__5ozi9G__icon",
  "item": "WhyItMatters-module__5ozi9G__item",
  "itemBody": "WhyItMatters-module__5ozi9G__itemBody",
  "itemTitle": "WhyItMatters-module__5ozi9G__itemTitle",
  "list": "WhyItMatters-module__5ozi9G__list",
  "section": "WhyItMatters-module__5ozi9G__section",
  "subtitle": "WhyItMatters-module__5ozi9G__subtitle",
});
